// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__FfwHg","addWidgetButton":"Header_addWidgetButton__2oB-6","dashboardTabs":"Header_dashboardTabs__TGWJA","active":"Header_active__3whCD"};